import {roomContainsPoint} from '@artemis-group/aiw-contracts';
import type {CanvasPayload} from '../components/proposal-canvas-import';
import type {PlanGeometry} from '@artemis-group/aiw-contracts';

export type ScotiaTrace = {metres:number;rooms:string[];segments:number;confirmed:boolean};

/** A drawing estimate is context for a material line, never its order or labour quantity. */
export function scotiaTrace(payload:CanvasPayload|null|undefined):ScotiaTrace|null{
 const runs=(payload?.floors??[]).flatMap(floor=>(floor.trims??[])
  .filter(t=>t.kind.toLowerCase()==='scotia'&&t.length_m!==null&&Number.isFinite(t.length_m)&&t.length_m>0)
  .map(t=>({metres:t.length_m!,room:t.room||floor.name,confirmed:t.measurement_confirmed===true})));
 if(!runs.length)return null;
 return {metres:Math.round(runs.reduce((n,r)=>n+r.metres,0)*100)/100,
  rooms:[...new Set(runs.map(r=>r.room))],segments:runs.length,confirmed:runs.every(r=>r.confirmed)};
}

const pathLength=(points:{x:number;y:number}[])=>points.slice(1).reduce((n,p,i)=>n+Math.hypot(p.x-points[i]!.x,p.y-points[i]!.y),0);


/** Older saved Proposals kept traced points but no length; their path is still a visible estimate. */
export function scotiaTraceFromPlan(plan:PlanGeometry[]):ScotiaTrace|null{
 const runs=plan.flatMap(floor=>floor.trims.filter(t=>/scotia/i.test(t.kind)).map(t=>{
  const metres=t.length_m??pathLength(t.points);
  const first=t.points[0],last=t.points.at(-1);
  const midpoint=first&&last?{x:(first.x+last.x)/2,y:(first.y+last.y)/2}:null;
  const room=midpoint?floor.rooms.find(r=>roomContainsPoint(r.shape,r.shape_holes??[],midpoint))?.name:null;
  return {metres,room:room||floor.name,confirmed:t.measurement_confirmed===true&&t.length_m!==null};
 })).filter(t=>Number.isFinite(t.metres)&&t.metres>0);
 if(!runs.length)return null;
 return {metres:Math.round(runs.reduce((n,r)=>n+r.metres,0)*100)/100,
  rooms:[...new Set(runs.map(r=>r.room))],segments:runs.length,confirmed:runs.every(r=>r.confirmed)};
}
